var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.784,
    height: 51.643,
    viewBox: "0 0 54.784 51.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360",
    transform: "translate(-540.521 -168.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M540.521,220.2v-8.137h4.327v1.326h-2.776v2.035h2.507v1.3h-2.507v2.147h2.776V220.2Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M553.244,220.2l-.573-5.181c-.056-.506-.079-1.1-.079-1.1h-.022s-.112.584-.27,1.1l-1.54,5.181h-1.011L548.2,215.02c-.157-.517-.27-1.1-.27-1.1h-.022s-.023.6-.079,1.1l-.573,5.181h-1.472l1.011-8.137h1.8l1.417,4.754c.134.472.235,1.045.235,1.045h.023s.1-.573.236-1.045l1.4-4.754h1.8l1.012,8.137Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M555.9,220.2v-8.137h1.585V220.2Z",
    fill: "#23b6bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M569,212.956v.489h-8.124v-.489h3.447v-.393c0-.105-.026-.4-.026-.5l1.222.017a.1.1,0,0,1,.061.105.686.686,0,0,1-.035.183v.585Zm-.384,3.281v3.028c0,.654-.157.907-.995.907h-1.326l-.192-.55a7.491,7.491,0,0,0,.864.062c.349,0,.436-.027.436-.376v-2.583h-4.956v3.517h-1.2v-4.005Zm-1.038-2.269v1.754H562.3v-1.754Zm-.864,3.325v2h-3.586v-2Zm-3.229-2.836v.811h2.9v-.811Zm.768,3.324V218.8h1.327v-1.021Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M571.693,214.561a6.063,6.063,0,0,0-.366-1.212H571.1a9.644,9.644,0,0,1-1.239,1.134l-.428-.271a4.821,4.821,0,0,0,1.23-2.225l1.2.306c.017.008.052.017.052.061s-.026.07-.1.139a3.041,3.041,0,0,0-.288.376h2.059v.48h-1.44a7.161,7.161,0,0,1,.8.811Zm2.548,1.519h3.491v.488h-8.124v-.488h3.446v-.873h-2.678v-.489h2.678c0-.2-.017-.392-.035-.584l1.222.026a.132.132,0,0,1,.044.087.8.8,0,0,1-.044.149v.322H576.9v.489h-2.662Zm.428.916a1,1,0,0,0-.035-.323l1.187.07c.1.009.139.07.139.105,0,.061-.026.1-.1.244v.375h1.868v.489h-1.868v1.282c0,.768-.235.943-.986.943h-1.6l-.192-.541a9.786,9.786,0,0,0,1.169.087c.349,0,.419-.078.419-.462v-1.309h-3.4a10.768,10.768,0,0,1,1.711,1.125l-1.109.83a8.216,8.216,0,0,0-1.082-1.667l.341-.288h-1.527v-.489h5.061Zm.977-2.452a5.908,5.908,0,0,0-.471-1.2h-.419a7.5,7.5,0,0,1-.873.785l-.418-.245a3.643,3.643,0,0,0,.9-1.9l1.187.306c.035.017.035.035.035.052,0,.079-.087.14-.14.174-.1.14-.148.2-.262.35h2.549v.48h-1.676a8.743,8.743,0,0,1,.925.785Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M586.457,217.371v.489h-3.464v1.44c0,.724-.306.925-1.021.925h-1.527l-.148-.559a7.284,7.284,0,0,0,.968.079c.4,0,.489-.053.489-.454V217.86h-3.421v-.489h3.421v-.951l.881.07a5.47,5.47,0,0,0,.716-.794h-3.5v-.48h5.088v.611a15.927,15.927,0,0,1-1.946,1.186v.358Zm-4.651-3.525a7.189,7.189,0,0,0-.6-1.579l.454-.271a8.228,8.228,0,0,1,1.4,1.361l-.882.489h1.99l-.506-.244a4.941,4.941,0,0,0,.619-1.589l1.353.533a.047.047,0,0,1,.026.043.242.242,0,0,1-.183.183,11.737,11.737,0,0,1-1.248,1.074h2.024v1.684h-1.2v-1.2h-5.367v1.221h-1.178v-1.7h1.266a9.5,9.5,0,0,0-.768-1.449l.419-.288a5.894,5.894,0,0,1,1.588,1.248l-.724.489Z",
    fill: "#717071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M589.162,215.425a4.324,4.324,0,0,1,.82,2.382c0,1.152-.654,1.152-.916,1.152h-.532l-.175-.6a.839.839,0,0,0,.279.053c.114,0,.323,0,.323-.76a4.774,4.774,0,0,0-.611-2.172L589,212.86h-.75v7.373H587.19V212.38h2.967v.5l-.079.2h1.8v-.471a4.928,4.928,0,0,0-.027-.533l1.187.009c.061,0,.148.026.148.114s-.061.113-.113.139v.742h1.981v1.745h-.724v.4h-3.613v-.4h-.707V213.27Zm4.485,3.953c0,.253.017.3.253.3.332,0,.393-.053.428-.157a4.942,4.942,0,0,0,.078-.978,2.177,2.177,0,0,0,.9.3c-.157,1.135-.375,1.309-1.065,1.309h-.933c-.786,0-.847-.253-.847-.794v-2.5h-.436a3,3,0,0,1-2.6,3.42l-.34-.393c1.536-.5,1.833-1.291,1.8-3.027h-.908v-.48h5.157v.48h-1.483Zm-2.531-4.642h2.766v-1.169h-2.766Z",
    fill: "#717071"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M580.433,179.614a3.381,3.381,0,0,1,.351,1.408V196.1c0,1.112.657,1.648,1.461,1.19a3.565,3.565,0,0,0,1.461-2.855v-15.1a3.312,3.312,0,0,0-.3-1.3Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M575.413,183.889v15.354c0,1.112.658,1.605,1.461,1.1a3.83,3.83,0,0,0,1.461-2.948V182.2a3.3,3.3,0,0,0-.3-1.305l-2.971,1.586A3.389,3.389,0,0,1,575.413,183.889Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M570,186.862l.028,12.059a3.59,3.59,0,0,1-1.33,2.83,2.5,2.5,0,0,1-1.348.277v3.32a3.5,3.5,0,0,0,1.776-.441l2.1-1.272a3.981,3.981,0,0,0,1.725-3.069l-.036-15.423a3.3,3.3,0,0,0-.328-1.345l-2.98,1.591A3.383,3.383,0,0,1,570,186.862Z",
    fill: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M581.972,176.335,569.394,169.1a3.649,3.649,0,0,0-3.228-.172c-.812.46-.687,1.291.277,1.845l12.607,7.255a3.722,3.722,0,0,1,1.387,1.592l2.971-1.586A3.761,3.761,0,0,0,581.972,176.335Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M576.6,179.2l-12.423-7.148a3.646,3.646,0,0,0-3.228-.172c-.812.46-.688,1.29.276,1.845l12.452,7.165a3.724,3.724,0,0,1,1.387,1.591l2.972-1.586A3.776,3.776,0,0,0,576.6,179.2Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M571.16,182.166l-12.539-6.986a3.728,3.728,0,0,0-3.255-.141c-.818.464-.693,1.287.279,1.828l12.6,7.019a3.638,3.638,0,0,1,1.366,1.5l2.98-1.591A3.7,3.7,0,0,0,571.16,182.166Z",
    fill: "#23b6bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M565.684,201.549l-9.976-5.767a3.886,3.886,0,0,1-1.75-3.034v-8.3c0-1.112.793-1.577,1.763-1.032l6.942,3.9a3.818,3.818,0,0,1,1.761,3.012v.7c0,1.112-.789,1.564-1.75,1l-3.024-1.762c-.961-.56-1.747-.208-1.747.782a3.629,3.629,0,0,0,1.764,2.791l5.906,3.313c.97.544,1.765.079,1.766-1.033l.01-7.5a3.781,3.781,0,0,0-1.767-3L552.8,178.562a1.1,1.1,0,0,0-1.77,1.045v14.827a3.887,3.887,0,0,0,1.751,3.034l12.932,7.476a3.451,3.451,0,0,0,1.633.4v-3.321A3.852,3.852,0,0,1,565.684,201.549Z",
    fill: "#23b6bc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo_login.4d32d18c2804b0ce53db475392bb6ae1.svg";
export { ForwardRef as ReactComponent };